<div class="pb-4">
  <div class="max-content-width">
    <!-- Header -->
    <div class="mb-2 flex items-center justify-between">
      <div>
        <button
          type="button"
          (click)="doGoBack()"
          class="mt-1 mb-1 text-sm text-secondary hover:underline flex items-center gap-1"
        >
          ← Back to Groups
        </button>
        <h1 class="page-title">{{ group()?.name }}</h1>
        @if (group(); as g) {
          <p
            [class.italic]="!g.description"
            class="text-sm text-slate-700 mt-1"
            [class.text-gray-400]="!g.description"
          >
            {{ g.description || 'No description provided' }}
          </p>
        }
        <div class="flex items-center gap-3 mt-2 flex-wrap">
          <span class="text-sm text-gray-700 font-medium ml-1"
            >📆 {{ group()?.createdAt | date: 'MMM d, yyyy' }}</span
          >
        </div>
      </div>

      <div class="flex items-center gap-2">
        @if (group()) {
          <button
            type="button"
            (click)="copyInviteLink()"
            [disabled]="!group()?.inviteActive || !group()?.inviteToken"
            class="rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {{ copiedInviteGroupId() === group()?.id ? 'Copied' : 'Copy invite link' }}
          </button>
        }
        @if (isGroupOwner()) {
          <button type="button" (click)="openGroupEdit()" class="btn-medium-text">Edit</button>
        } @else if (group()) {
          <button
            type="button"
            (click)="askLeaveGroup()"
            class="inline-flex items-center justify-center rounded-lg transition-colors font-semibold px-3 py-2 text-sm border border-red-300 bg-white text-red-600 hover:bg-red-50 min-w-16 text-nowrap"
          >
            Leave
          </button>
        }
      </div>
    </div>

    <!-- Error Message -->
    @if (errorMessage()) {
      <div class="mb-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
        {{ errorMessage() }}
      </div>
    }

    <!-- Tab Bar -->
    <div class="mb-4">
      <div class="flex gap-0 border-b border-slate-200" role="tablist" aria-label="Group tabs">
        <button
          type="button"
          role="tab"
          [attr.aria-selected]="activeTab() === 'overview'"
          (click)="switchTab('overview')"
          class="px-5 py-3 text-sm font-semibold transition-colors relative"
          [class.text-secondary]="activeTab() === 'overview'"
          [class.text-slate-500]="activeTab() !== 'overview'"
          [class.hover:text-slate-700]="activeTab() !== 'overview'"
        >
          Overview
          @if (activeTab() === 'overview') {
            <span class="absolute bottom-0 left-0 right-0 h-0.5 bg-secondary rounded-full"></span>
          }
        </button>
        <button
          type="button"
          role="tab"
          [attr.aria-selected]="activeTab() === 'papers'"
          (click)="switchTab('papers')"
          class="px-5 py-3 text-sm font-semibold transition-colors relative"
          [class.text-secondary]="activeTab() === 'papers'"
          [class.text-slate-500]="activeTab() !== 'papers'"
          [class.hover:text-slate-700]="activeTab() !== 'papers'"
        >
          Papers
          @if (activeTab() === 'papers') {
            <span class="absolute bottom-0 left-0 right-0 h-0.5 bg-secondary rounded-full"></span>
          }
        </button>
        <button
          type="button"
          role="tab"
          [attr.aria-selected]="activeTab() === 'reading-lists'"
          (click)="switchTab('reading-lists')"
          class="px-5 py-3 text-sm font-semibold transition-colors relative"
          [class.text-secondary]="activeTab() === 'reading-lists'"
          [class.text-slate-500]="activeTab() !== 'reading-lists'"
          [class.hover:text-slate-700]="activeTab() !== 'reading-lists'"
        >
          Reading Lists
          @if (activeTab() === 'reading-lists') {
            <span class="absolute bottom-0 left-0 right-0 h-0.5 bg-secondary rounded-full"></span>
          }
        </button>
      </div>
    </div>

    <!-- Tab Content -->
    <div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

@if (group()) {
  <app-group-edit-modal
    [open]="showGroupEditModal()"
    [group]="group()!"
    (openChange)="showGroupEditModal.set($event)"
    (saved)="saveGroup($event)"
    (deleted)="deleteGroup()"
  ></app-group-edit-modal>
}

<app-confirm-modal
  [open]="showLeaveConfirm()"
  [title]="'Leave group?'"
  [message]="leaveMessage"
  [confirmText]="'Leave group'"
  [cancelText]="'Cancel'"
  [confirmVariant]="'danger'"
  [loading]="leaveLoading()"
  size="sm"
  (openChange)="showLeaveConfirm.set($event)"
  (confirmed)="confirmLeaveGroup()"
  (canceled)="cancelLeaveGroup()"
></app-confirm-modal>

@if (leaveError()) {
  <div class="mt-4 rounded-md border border-red-200 bg-red-50 p-3">
    <p class="text-sm text-red-700">{{ leaveError() }}</p>
  </div>
}
